// src/pages/ItemStock/components/exportItemStockReportCsv.js

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtQty = (val, item) => {
  if (!val) return `0 ${item.unit_symbol}`;
  if (item.conversion === 1) {
    return `${parseFloat(val).toFixed(2)} ${item.unit_symbol}`;
  }
  return `${Math.trunc(val / item.conversion)} ${item.unit_symbol}, ${
    val % item.conversion
  } ${item.base_unit_name}`;
};

/**
 * @param {object} params
 * @param {Array}  params.list     - from Redux state.itemStock.list
 * @param {object} params.filters  - { filterType, itemId, groupId, ... }
 * @param {string} params.title
 * @param {string} params.filename
 */
export const exportItemStockReportCsv = ({
  list,
  filters,
  title    = "Item Stock Report",
  filename = "item_stock_report",
}) => {
  const rows = [[title], []];

  const headers = [
    "No.", "Code", "Item Name", "Group", "Category",
    "Opening Stock", "Purchased", "Production", "Sold", "Consume",
    "Purchase Return", "Sales Return", "Transfer", "Received", "Damage",
    "Costing Rate (AVG.)", "Current Stock", "Stock Value",
  ].map(escape);

  rows.push(headers);

  list.forEach((row, i) => {
    rows.push([
      i + 1,
      row.item_code        || "",
      row.item_name        || "",
      row.group_name       || "",
      row.category_name    || "",
      fmtQty(row.opening_qty,          row),
      fmtQty(row.purchase_qty,         row),
      fmtQty(row.production_qty,       row),
      fmtQty(row.sale_qty,             row),
      fmtQty(row.consume_qty,          row),
      fmtQty(row.purchase_return_qty,  row),
      fmtQty(row.sale_return_qty,      row),
      fmtQty(row.transfer_out_qty,     row),
      fmtQty(row.transfer_in_qty,      row),
      fmtQty(row.damage_qty,           row),
      `${parseFloat(row.average_rate || 0).toFixed(2)} PER ${
        row.conversion === 1 ? row.unit_symbol : row.base_unit_name
      }`,
      row.display_qty      ?? "",
      parseFloat(row.stock_value || 0).toFixed(2),
    ].map(escape));
  });

  // Grand totals — raw numeric sums (unit-aware display not possible in CSV totals)
  const totals = list.reduce(
    (acc, row) => {
      acc.opening_qty         += Number(row.opening_qty)         || 0;
      acc.purchase_qty        += Number(row.purchase_qty)        || 0;
      acc.production_qty      += Number(row.production_qty)      || 0;
      acc.sale_qty            += Number(row.sale_qty)            || 0;
      acc.consume_qty         += Number(row.consume_qty)         || 0;
      acc.purchase_return_qty += Number(row.purchase_return_qty) || 0;
      acc.sale_return_qty     += Number(row.sale_return_qty)     || 0;
      acc.transfer_out_qty    += Number(row.transfer_out_qty)    || 0;
      acc.transfer_in_qty     += Number(row.transfer_in_qty)     || 0;
      acc.damage_qty          += Number(row.damage_qty)          || 0;
      acc.stock_value         += Number(row.stock_value)         || 0;
      return acc;
    },
    {
      opening_qty: 0, purchase_qty: 0, production_qty: 0,
      sale_qty: 0, consume_qty: 0, purchase_return_qty: 0,
      sale_return_qty: 0, transfer_out_qty: 0, transfer_in_qty: 0,
      damage_qty: 0, stock_value: 0,
    }
  );

  rows.push([]); // spacer
  rows.push([
    "Grand Total", "", "", "", "",
    totals.opening_qty.toFixed(2),
    totals.purchase_qty.toFixed(2),
    totals.production_qty.toFixed(2),
    totals.sale_qty.toFixed(2),
    totals.consume_qty.toFixed(2),
    totals.purchase_return_qty.toFixed(2),
    totals.sale_return_qty.toFixed(2),
    totals.transfer_out_qty.toFixed(2),
    totals.transfer_in_qty.toFixed(2),
    totals.damage_qty.toFixed(2),
    "", "",
    totals.stock_value.toFixed(2),
  ].map(escape));

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};